import Image, { type ImageProps } from '2-core-elements/Image/Image';

export type LocationCardProps = {
    img?: Pick<ImageProps, 'imgSrc' | 'imgAlt' | 'imgHeight' | 'imgWidth' | 'imgSrcSet'>;
    link?: { href: string; label?: string; target?: '_self' | '_blank' };
    title: string;
    children?: React.ReactNode;
};

const LocationCard = ({
    img,
    link = { href: '', label: '', target: '_self' },
    title,
    children,
}: LocationCardProps): JSX.Element => {
    return (
        <div className={`location-card`}>
            {img && (
                <a href={link.href} className="card-img">
                    <Image aspectRatio="3/2" imgSrc={img.imgSrc} imgAlt={img.imgAlt} imgSrcSet={img.imgSrcSet} />
                </a>
            )}
            <div className="card-content">
                <h3 className="card-title">
                    <a href={link.href}>
                        {title}
                    </a>
                </h3>
                {children && (
                    <div className="card-description">
                        {children}
                    </div>
                )}
            </div>
        </div>
    );
};

export default LocationCard;
